import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';

export interface Experiments {
  signupWithBackground: boolean;
  signupWithGiveMeFive: boolean;
  signupWithGiveMeFiveDesc: boolean;
  signupWithDelayedLogin: boolean;
  signupWithThreeVersusFive: boolean;
  signupWithProductNaming: boolean;
}

const initialState: Experiments = {
  signupWithBackground: false,
  signupWithGiveMeFive: false,
  signupWithGiveMeFiveDesc: false,
  signupWithDelayedLogin: false,
  signupWithThreeVersusFive: false,
  signupWithProductNaming: false,
};

export const isSignupWithBackgroundExperiment = (state: Experiments): boolean => {
  if (!state) {
    return null;
  }

  return Boolean(state.signupWithBackground);
};

export const isSignupWithGiveMeFiveExperiment = (state: Experiments): boolean => {
  if (!state) {
    return null;
  }

  return Boolean(state.signupWithGiveMeFive);
};

export const isSignupWithGiveMeFiveDescExperiment = (state: Experiments): boolean => {
  if (!state) {
    return null;
  }

  return Boolean(state.signupWithGiveMeFiveDesc);
};

export const isSignupWithDelayedLogin = (state: Experiments): boolean => {
  if (!state) {
    return false;
  }

  return state.signupWithDelayedLogin;
};

export const isSignupWithThreeVersusFive = (state: Experiments): boolean => {
  if (!state) {
    return false;
  }

  return state.signupWithThreeVersusFive;
};

export const isSignupWithProductNaming = (state: Experiments): boolean => {
  if (!state) {
    return false;
  }

  return state.signupWithProductNaming;
};

export default function experiments(
  state: Experiments = initialState,
  action: Action<any> // tslint:disable-line no-any
): Experiments {
  switch (action.type) {
    case Actions.SET_SIGNUP_WITH_BACKGROUND:
      return Object.assign({}, state, { signupWithBackground: true });
    case Actions.SET_SIGNUP_WITH_GIVE_ME_FIVE:
      return Object.assign({}, state, { signupWithGiveMeFive: true });
    case Actions.SET_SIGNUP_WITH_GIVE_ME_FIVE_DESC:
      return Object.assign({}, state, { signupWithGiveMeFiveDesc: true });
    case Actions.SET_SIGNUP_WITH_DELAYED_LOGIN:
      return Object.assign({}, state, { signupWithDelayedLogin: true });
    case Actions.SET_SIGNUP_WITH_THREE_VERSUS_FIVE:
      return Object.assign({}, state, { signupWithThreeVersusFive: true });
    case Actions.SET_SIGNUP_WITH_PRODUCT_NAMING:
      return Object.assign({}, state, { signupWithProductNaming: true });
    default:
      return state;
  }
}
